import { Node, NodeConfig } from "konva/lib/Node";
import { Vector2d } from "konva/lib/types";

export const createDragBoundHandler = (canvasDimensions: {
  width: number;
  height: number;
}): ((this: Node<NodeConfig>, pos: Vector2d) => Vector2d) => {
  /**
   * It should be a function declaration because it needs an acess to "this" context.
   */
  return function (pos) {
    pos.x = Math.min(
      0,
      Math.max(pos.x, canvasDimensions.width * (1 - this.getAbsoluteScale().x))
    );
    pos.y = Math.min(
      0,
      Math.max(pos.y, canvasDimensions.height * (1 - this.getAbsoluteScale().y))
    );

    return pos;
  };
};
